import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { getFunnelMentionRedirectUrl } from "../utils/funnelMentionRedirects";

/**
 * Route guard for the two funnel entry pages that campaigns link to directly.
 * If the URL's mention has a successor funnel (see FUNNEL_MENTION_REDIRECTS, plus
 * QUESTIONNAIRE_MENTION_REDIRECTS on the questionnaire route), the visitor is
 * replaced onto it before the page mounts — so the old funnel never paints and
 * never fires its API call. Otherwise the page renders as is.
 * In-app links already point at the successor; this only catches old links
 * (ads, bookmarks, emails).
 *
 * `replace` keeps the redirect out of history: Back returns to the ad, not
 * into the redirect.
 */
const FunnelMentionRedirect: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { country, mention, category } = useParams();
  const location = useLocation();

  // Start consultation routes carry `:mention`, the questionnaire route `:category`.
  const page = category !== undefined ? "questionnaire" : "start-consultation";
  const redirectUrl = getFunnelMentionRedirectUrl(country, mention ?? category, location, page);

  if (redirectUrl) return <Navigate to={redirectUrl} replace />;

  return children;
};

export default FunnelMentionRedirect;
